module.exports = __webpack_public_path__ + "img/main-banner-mobile.438b9ed4.png";